// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579694328333
      var cssReload = require("../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Loader/Loader.scss
// module id = ./src/components/Common/Loader/Loader.scss
// module chunks = 0